import * as React from "react";
import Loadable from "react-loadable";
import { RouteComponentProps } from "react-router-dom";
import { useSelector } from "react-redux";

import { LOADABLE_COMPONENT_DELAY } from "@config/consts";

import { ImpersonatorNotification } from "@ui/Molecules";

import {
  isUserAdmin,
  isAdminImpersonator as isAdminImpersonatorSelector,
} from "@soft/redux/user/user.selectors";

import { HomeCleaningPageSkeleton } from "./Booking.skeletons";

const LoadableHomeCleaning: any = Loadable({
  loader: () => import("./HomeCleaning/HomeCleaning"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.HomeCleaning;
    return <Component {...props} />;
  },
  loading: HomeCleaningPageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const Booking = (props: RouteComponentProps): React.ReactElement => {
  const isAdmin = useSelector(isUserAdmin);
  const isAdminImpersonator = useSelector(isAdminImpersonatorSelector);

  if (isAdmin && !isAdminImpersonator) {
    return <ImpersonatorNotification />;
  }

  return <LoadableHomeCleaning {...props} />;
};

export { Booking };
